import React, { useContext, useState } from 'react';
import { ModalContext, withToolbarContext } from 'ricos-context';
import { Node_Type } from 'ricos-schema';
import { getCustomHeadingsLabel } from 'wix-rich-content-toolbars-modals';

import { DropdownArrowIcon } from '../../../icons';
import { ToolbarButton } from '../ToolbarButton';

const CustomHeadingButton = ({ toolbarItem, context, dataHook }) => {
  const { isMobile, t, getEditorCommands } = context || {};
  const modalService = useContext(ModalContext) || {};
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);

  const editorCommands = getEditorCommands?.();

  const selectedHeading = toolbarItem.attributes.selectedHeading;
  const Label = getCustomHeadingsLabel(selectedHeading, t, editorCommands);

  const tooltip = t(toolbarItem.presentation?.tooltip);
  return (
    <ToolbarButton
      ref={setReferenceElement}
      disabled={toolbarItem.attributes.disabled}
      isMobile={isMobile}
      active={modalService.isModalOpen(`${Node_Type.HEADING}.modal`)}
      tooltip={tooltip}
      onClick={e => toolbarItem.commands?.click({ referenceElement, clickFromKeyboard: !e.detail })}
      icon={() => (
        <>
          {Label}
          <DropdownArrowIcon />
        </>
      )}
      dataHook={dataHook}
    />
  );
};

export default withToolbarContext(CustomHeadingButton);
